import React from 'react';

/**
 * Status: *finished*.
 * Category: Boxes
 *
 * There should be a minimum of three- and a maximum of eight boxes when using this component.
 **/
var FeatureBoxes = function FeatureBoxes(_ref) {
  var children = _ref.children,
    hasBorder = _ref.hasBorder,
    size = _ref.size;
  return /*#__PURE__*/React.createElement("div", {
    className: "feature-boxes"
  }, React.Children.map(children, function (child) {
    return /*#__PURE__*/React.cloneElement(child, {
      hasBorder: hasBorder,
      size: size
    });
  }));
};
export default FeatureBoxes;